// Firebase App (the core Firebase SDK) is always required and must be listed first
import { getApp, initializeApp } from 'firebase/app';
// Add Firebase products you want to use here
import { connectFirestoreEmulator, getFirestore } from 'firebase/firestore';
import { connectAuthEmulator, getAuth } from 'firebase/auth';
import { connectFunctionsEmulator, getFunctions } from 'firebase/functions';
import { connectStorageEmulator, getStorage } from 'firebase/storage';
import { getAnalytics } from 'firebase/analytics';
import { getRemoteConfig } from 'firebase/remote-config';
import defaultRemoteConfig from './defaultRemoteConfig';

const firebaseConfig = {
  apiKey: process.env.FIREBASE_API_KEY,
  authDomain: process.env.FIREBASE_AUTH_DOMAIN,
  projectId: process.env.FIREBASE_PROJECT_ID,
  storageBucket: process.env.FIREBASE_STORAGE_BUCKET,
  messagingSenderId: process.env.FIREBASE_MESSAGING_SENDER_ID,
  appId: process.env.FIREBASE_APP_ID,
  measurementId: process.env.FIREBASE_MEASUREMENT_ID,
};

const firebaseApp = initializeApp(firebaseConfig);

const db = getFirestore();
const auth = getAuth(getApp());
const functions = getFunctions(getApp());
const analytics = getAnalytics(firebaseApp);

const remoteConfig = getRemoteConfig(firebaseApp);
remoteConfig.settings.minimumFetchIntervalMillis =
  window.location.hostname === 'localhost' ? 60000 : 43200000; // re-fetch every 12 hours

// You can set in-app default parameter values in the Remote Config object
// so that your app behaves as intended before it connects to the Remote Config backend
remoteConfig.defaultConfig = defaultRemoteConfig;

const storage = getStorage(firebaseApp);
// Points to the root reference
// const storageRef = ref(storage);

if (window.location.hostname === 'localhost') {
  connectFirestoreEmulator(db, 'localhost', 8080);
  connectAuthEmulator(auth, 'http://localhost:9099');
  connectFunctionsEmulator(functions, 'localhost', 5001);
  connectStorageEmulator(storage, 'localhost', 9199);
}

export { firebaseApp, db, auth, functions, storage, analytics, remoteConfig };
